import { useMediaQuery, useTheme } from '@spothero/ui';
const useIsMobile = () => {
    const theme = useTheme();
    const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.mobileXL})`, {
        ssr: false,
    });
    return isMobile;
};
export default useIsMobile;
